/* Reviews widget for Shopify theme assets */
/* Usage: <div data-reviews data-product="{{ product.handle }}" data-endpoint="/apps/reviews"></div>
   If data-endpoint is empty, the widget renders read-only from inline JSON
   embedded as <script type="application/json" data-reviews-initial> ... </script> */
(function(){
  const ROOT_SEL = '[data-reviews]';
  const DEFAULT_AVATAR = 'data:image/svg+xml;utf8,%3Csvg xmlns%3D"http%3A//www.w3.org/2000/svg" viewBox%3D"0 0 64 64"%3E%3Ccircle cx%3D"32" cy%3D"24" r%3D"14" fill%3D"%23d9d9d9"/%3E%3Cpath d%3D"M8 58a24 24 0 0 1 48 0" fill%3D"%23e6e6e6"/%3E%3C/svg%3E';
  function el(t,c,x){const e=document.createElement(t);if(c)e.className=c;if(x!=null)e.textContent=x;return e;}
  function starRow(r){const w=el('div','stars');let s='';for(let i=1;i<=5;i++)s+=i<=r?'★':'☆';w.textContent=s;return w;}
  function fmtDate(i){try{return new Date(i).toLocaleDateString();}catch{return ''}}
  function distBar(cnt,total){const w=el('div','dist');for(let i=5;i>=1;i--){const row=el('div','dist-row');row.appendChild(starRow(i));const bar=el('div','bar');const f=el('span');f.style.width=total?((cnt[i]||0)/total*100).toFixed(0)+'%':'0%';bar.appendChild(f);row.appendChild(bar);row.appendChild(el('div','muted',String(cnt[i]||0)));w.appendChild(row);}return w;}
  async function jget(u){
    const r=await fetch(u,{credentials:'omit'});
    if(!r.ok) throw new Error('HTTP '+r.status);
    try { return await r.json(); } catch(e){ console.error('Reviews JSON parse failed for', u); throw new Error('Invalid JSON'); }
  }
  function parseInline(container){
    const s = container.querySelector('script[data-reviews-initial]');
    if (!s) return null;
    try { return JSON.parse(s.textContent.trim()); } catch { return null; }
  }
  async function jpost(u,b){const r=await fetch(u,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(b)});if(!r.ok)throw new Error('HTTP '+r.status);return r.json();}
  function render(container,state){
    container.innerHTML='';
    const root=el('div','reviews');
    root.appendChild(el('h2',null,'CUSTOMER REVIEWS'));
    const summary=el('div','summary');
    const left=el('div','left');
    left.appendChild(starRow(Math.round(state.stats.average)));
    left.appendChild(el('div','muted',state.stats.average.toFixed(2)+' out of 5\nBased on '+state.stats.total+' reviews'));
    summary.appendChild(left);
    summary.appendChild(distBar(state.stats.distribution,state.stats.total));
    const cta=el('div','cta');
    const hasEndpoint = !!(container.getAttribute('data-endpoint'));
    if (hasEndpoint) {
      const btn=el('button','btn','Write a review');btn.addEventListener('click',()=>openModal(container));cta.appendChild(btn);
    }
    summary.appendChild(cta);root.appendChild(summary);
    const controls=el('div','controls');const sel=el('select');[['recent','Most Recent'],['high','Highest'],['low','Lowest']].forEach(([v,l])=>{const o=el('option');o.value=v;o.textContent=l;sel.appendChild(o);});sel.value = state.sort || 'recent';sel.addEventListener('change',()=>{state.sort=sel.value;state.page=1;renderList(list,state);renderPagination(pager,state,list);});controls.appendChild(sel);root.appendChild(controls);
    const list=el('div','list');root.appendChild(list);
    const pager=el('div','reviews-pagination');root.appendChild(pager);
    renderList(list,state);renderPagination(pager,state,list);
    if (hasEndpoint) root.appendChild(buildModal(container));
    container.appendChild(root);
  }
  function renderList(target,state){
    target.innerHTML='';const list=[...state.reviews];
    if(state.sort==='high')list.sort((a,b)=>b.rating-a.rating||(new Date(b.createdAt)-new Date(a.createdAt)));
    else if(state.sort==='low')list.sort((a,b)=>a.rating-b.rating||(new Date(b.createdAt)-new Date(a.createdAt)));
    else list.sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));
    const pageSize = state.pageSize || 10;
    const total = list.length;
    if(!total){target.appendChild(el('div','muted','Be the first to write a review'));return;}
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    if (!state.page || state.page < 1) state.page = 1;
    if (state.page > totalPages) state.page = totalPages;
    const start = (state.page - 1) * pageSize;
    const pageItems = list.slice(start, start + pageSize);
    for(const r of pageItems){
      const card=el('div','card');
      card.appendChild(starRow(r.rating));
      const h=el('div','header');
      const av=el('span','avatar');
      const i=new Image(); i.loading='lazy'; i.referrerPolicy='no-referrer'; i.src=(r.avatar&&r.avatar.trim())||DEFAULT_AVATAR; av.appendChild(i);
      h.appendChild(av);
      h.appendChild(el('div','name',r.name||'Anonymous'));
      h.appendChild(el('div','muted',' \u2022 '+fmtDate(r.createdAt)));
      card.appendChild(h);
      if(r.title)card.appendChild(el('div','title',r.title));
      if(r.text)card.appendChild(el('div','body',r.text));
      target.appendChild(card);
    }
  }
  function renderPagination(target,state,listNode){
    target.innerHTML='';
    const total = state.reviews.length;
    const pageSize = state.pageSize || 10;
    const totalPages = Math.ceil(total / pageSize);
    if (totalPages <= 1) return;
    const page = state.page || 1;

    function addButton(label, targetPage, extra){
      const btn = el('button','reviews-page-btn'+(extra?' '+extra:''), label);
      btn.type = 'button';
      if (targetPage === page && extra === 'is-number') {
        btn.classList.add('is-active');
        btn.disabled = true;
      } else if (targetPage < 1 || targetPage > totalPages) {
        btn.disabled = true;
      } else {
        btn.addEventListener('click',()=>{
          state.page = targetPage;
          renderList(listNode,state);
          renderPagination(target,state,listNode);
        });
      }
      target.appendChild(btn);
    }

    // Previous arrow
    addButton('‹', page - 1, 'is-arrow');

    // Sliding window of page numbers (4 visible at a time)
    const windowSize = 4;
    let start = page - Math.floor(windowSize / 2);
    if (start < 1) start = 1;
    let end = start + windowSize - 1;
    if (end > totalPages) { end = totalPages; start = Math.max(1, end - windowSize + 1); }

    for (let i = start; i <= end; i++) {
      addButton(String(i), i, 'is-number');
    }

    // Ellipsis when there are more pages ahead
    if (end < totalPages) {
      const dots = el('span','reviews-page-ellipsis','…');
      target.appendChild(dots);
    }

    // Next and jump-to-last arrows
    addButton('›', page + 1, 'is-arrow');
    addButton('»', totalPages, 'is-arrow');
  }
  function buildModal(container){
    const m=el('div','modal');const d=el('div','dialog');d.appendChild(el('h3',null,'Write a review'));const star=el('div','star-input');let sel=0;const stars=[];for(let i=1;i<=5;i++){const s=el('span',null,'★');s.addEventListener('mouseover',()=>hl(i));s.addEventListener('click',()=>{sel=i;hl(i);});stars.push(s);star.appendChild(s);}function hl(n){stars.forEach((s,ix)=>s.classList.toggle('active',ix<n));}hl(0);
    const f=el('form');f.appendChild(star);const r1=el('div','form-row');const nameI=el('input');nameI.placeholder='Your name';r1.appendChild(nameI);const avI=el('input');avI.placeholder='Avatar URL (optional)';r1.appendChild(avI);f.appendChild(r1);const r2=el('div','form-row single');const titleI=el('input');titleI.placeholder='Review title (optional)';r2.appendChild(titleI);f.appendChild(r2);const r3=el('div','form-row single');const textI=el('textarea');textI.placeholder='Share your experience...';r3.appendChild(textI);f.appendChild(r3);f.appendChild(el('div','help','New reviews are queued for approval.'));
    const actions=el('div','actions');const cancel=el('button','btn secondary','Cancel');cancel.type='button';cancel.addEventListener('click',()=>m.classList.remove('open'));const submit=el('button','btn','Submit review');submit.type='submit';actions.appendChild(cancel);actions.appendChild(submit);f.appendChild(actions);
    f.addEventListener('submit',async(e)=>{e.preventDefault();const root=container;const endpoint=root.getAttribute('data-endpoint')||'/apps/reviews';const product=(root.getAttribute('data-product')||'').toLowerCase();if(!product){alert('Missing product identifier');return;}if(sel<1){alert('Please select a rating');return;}submit.disabled=true;submit.textContent='Submitting...';
      try{await jpost(endpoint+'/reviews',{product,rating:sel,name:nameI.value.trim()||'Anonymous',avatar:avI.value.trim(),title:titleI.value.trim(),text:textI.value.trim()});submit.textContent='Submitted!';setTimeout(()=>{m.classList.remove('open');submit.disabled=false;submit.textContent='Submit review';},700);loadAndRender(container);}catch(err){console.error(err);alert('Failed to submit review');submit.disabled=false;submit.textContent='Submit review';}});
    d.appendChild(f);m.appendChild(d);return m;}
  function openModal(container){container.querySelector('.reviews .modal').classList.add('open');}
  function computeStats(list){
    const total=list.length; const counts={1:0,2:0,3:0,4:0,5:0}; let sum=0;
    list.forEach(r=>{counts[r.rating]=(counts[r.rating]||0)+1; sum+=r.rating;});
    const average = total? +(sum/total).toFixed(2):0; return {total, average, distribution:counts};
  }
  async function loadAndRender(container){
    const root=container;
    const endpoint=(root.getAttribute('data-endpoint')||'').trim();
    const product=(root.getAttribute('data-product')||'').toLowerCase();
    if (endpoint) {
      const base = endpoint.replace(/\/+$/,'');
      try {
        const url = `${base}/reviews?product=${encodeURIComponent(product)}`;
        const data=await jget(url);
        const state={reviews:data.reviews||[],stats:data.stats||{total:0,average:0,distribution:{}},sort:'recent',page:1,pageSize:10}; return render(container,state);
      } catch(err){
        console.error('Reviews fetch failed; falling back to metafield JSON', err);
        const inline = parseInline(container) || { reviews: [] };
        const reviews = inline.reviews || inline;
        const state={reviews:reviews, stats: computeStats(reviews), sort:'recent',page:1,pageSize:10};
        return render(container, state);
      }
    }
    const inline = parseInline(container) || { reviews: [] };
    const reviews = inline.reviews || inline;
    const state={reviews:reviews, stats: computeStats(reviews), sort:'recent',page:1,pageSize:10};
    render(container, state);
  }
  function init(){document.querySelectorAll(ROOT_SEL).forEach((node)=>{const wrap=document.createElement('div');node.appendChild(wrap);loadAndRender(node);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
